import { nav } from "components/structure/navigation";
import { format, parseISO } from 'date-fns';
import { toZonedTime  } from 'date-fns-tz';
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  },
  getContentAnchorEl: null,
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "center"
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "center"
  },
  variant: "menu"
};

const options = [
  "Oliver Hansen",
  "Van Henry",
  "April Tucker",
  "Ralph Hubbard",
  "Omar Alexander",
  "Carlos Abbott",
  "Miriam Wagner",
  "Bradley Wilkerson",
  "Virginia Andrews",
  "Kelly Snyder"
];

const convertDateString = (dateString)=> {
  const parts = dateString.split('-');
  return `${parts[2]}/${parts[1]}/${parts[0]}`;
}
const formatDate = (dateString) => {
  const date = new Date(dateString);
  return format(date, "dd/MM/yyyy");
};

const formatDateDetails = (dateString) => {
  if(!dateString) return
  const date = new Date(dateString);
  return format(date, "dd/MMM/yyyy HH:mm:ss");
};
function htmlToPlainText(html) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || "";
}

function getModuleNameFromPath(pathname) {
  const route = nav.find(item => {
    const regexPath = item.path.replace(/:\w+/g, '[^/]+');
    const regex = new RegExp(`^${regexPath.toLowerCase()}$`);
    return regex.test(pathname.toLowerCase());
  });
  return route ? route.name : null;
}
const formatDateToLocal = (utcDate) => {
  // Parse the UTC date and convert it to the local time zone
  const zonedDate = toZonedTime(parseISO(utcDate), Intl.DateTimeFormat().resolvedOptions().timeZone);
  // Format the date in the desired format: 'DD/MM/YYYY | HH:mm'
  return format(zonedDate, 'dd/MM/yyyy | HH:mm');
};
const convertUtcToLocalDate = (utcDate) => {
  const date = parseISO(utcDate); // Parse the UTC string to a Date object
  const localDateString = format(date, "yyyy-MM-dd HH:mm:ss"); // Format the local date
  return localDateString;
};
const formatSurveyDate = (dateString) => {
  if (!dateString) return '';

  const datePart = dateString.split('T')[0]; // e.g., "2025-05-12"
  const [year, month, day] = datePart.split('-');

  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", 
                      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  return `${day}-${monthNames[parseInt(month, 10) - 1]}-${year.slice(-2)}`;
};
const normalizeForComparison = (value) =>
  String(value ?? "").trim().toLowerCase();

const equalsIgnoreCase = (value, expected) =>
  normalizeForComparison(value) === normalizeForComparison(expected);

const hasSelectedOption = (selectedValue, expected) =>
  Array.isArray(selectedValue) &&
  selectedValue.some((value) => equalsIgnoreCase(value, expected));

const includesIgnoreCase = (value, expectedValues) =>
  expectedValues.some((expected) => equalsIgnoreCase(value, expected));

export { MenuProps, options, formatDate ,formatDateDetails ,htmlToPlainText,
  getModuleNameFromPath,convertDateString ,formatDateToLocal,convertUtcToLocalDate,formatSurveyDate,
  normalizeForComparison, equalsIgnoreCase, hasSelectedOption, includesIgnoreCase };
